import { useMixpanelTableAction } from '@/utilities/mixpanel';
import { computed, ref } from 'vue';
export function useUsersSorting() {
    const getOrderBy = ref('name');
    const currentSort = computed(() => {
        if (!getOrderBy.value)
            return;
        const isDescending = getOrderBy.value.startsWith('-');
        const prop = isDescending ? getOrderBy.value.substring(1) : getOrderBy.value;
        const order = isDescending ? 'descending' : 'ascending';
        return { prop, order };
    });
    function sortTable({ prop, order }) {
        getOrderBy.value = !order || order === 'ascending' ? prop : `-${prop}`;
        useMixpanelTableAction('settings-users_clicked_sort', prop, { order: order || 'ascending' });
    }
    return {
        getOrderBy,
        currentSort,
        sortTable,
    };
}
